import { render, staticRenderFns } from "./vClientLimit.vue?vue&type=template&id=b0725e2a&"
import script from "./vClientLimit.vue?vue&type=script&lang=js&"
export * from "./vClientLimit.vue?vue&type=script&lang=js&"
import style0 from "./vClientLimit.vue?vue&type=style&index=0&id=b0725e2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports